/**
 *
 * jQuery Accordion Plugin
 */

'use strict';

import $ from 'jquery';

$.fn.accordion = function(options) {
    var plugin = this;

    var defaults = {
        hiddenOnLoad: true,
        singleOpen: true
    };

    plugin.settings = $.extend({}, defaults, options);

    return this.each(function() {

        var $header  = $(this).find('.header');
        var $content = $(this).find('.content');

        // State classes use -accClosed / -accOpen (not "close") so Bootstrap's
        // global .close { float: right } does not break accordion row layout.
        if(plugin.settings.hiddenOnLoad) {
            $header.parent().addClass('-accClosed initially-hidden');
        } else {
            $header.parent().addClass('-accOpen');
        }

        $header.on('click', function() {

            if(!$(this).parent().hasClass('-accOpen') && plugin.settings.singleOpen) {
                $header.parent().removeClass('-accOpen').addClass('-accClosed');
                $content.slideUp();
            }

            $(this)
                .parent()
                .toggleClass('-accOpen -accClosed');

            $(this)
                .siblings('.content')
                .slideToggle();

        });

    });
};
